import type { ToofiNudgeEventType } from "@/hooks/useToofiNudges";

export const getToofiNudgeExplanation = (eventType: ToofiNudgeEventType) => {
  switch (eventType) {
    case "review_due":
      return "You have review waiting on a topic Toofi thinks needs refresh.";
    case "plan_reminder":
      return "You still have plan work left for today.";
    case "deadline_pressure":
      return "Your target date is close and some weak areas still need attention.";
    case "session_resume":
      return "You stopped in the middle of a study step recently.";
    case "celebration":
      return "Recent study signals show progress worth reinforcing.";
    case "streak_break":
      return "Your recent study streak slipped, so Toofi is nudging you back into rhythm.";
    default:
      return "Toofi is surfacing the next study move that looks most useful right now.";
  }
};

export const getToofiNudgeStatus = ({
  dismissedAt,
  actedOnAt,
}: {
  dismissedAt?: string | null;
  actedOnAt?: string | null;
}) => {
  if (dismissedAt) return "dismissed" as const;
  if (actedOnAt) return "acted_on" as const;
  return "active" as const;
};

export const getToofiNudgeDestinationLabel = (ctaLink?: string | null) => {
  if (!ctaLink) return null;
  if (ctaLink.startsWith("/student/passes/")) return "Open pass";
  if (ctaLink.startsWith("/student/review")) return "Open review";
  if (ctaLink.startsWith("/student/study-time")) return "Open study time";
  if (ctaLink.startsWith("/resource/")) return "Open resource";
  if (ctaLink.startsWith("/student/orders")) return "Open orders";
  if (ctaLink.startsWith("/student")) return "Open page";
  return "Open link";
};
